module.exports = __webpack_public_path__ + "static/DSC_9490-5b26b2b84f0680cb2790d1f68d93ae1e.jpg";